import { useState } from "react";
import { IonContent, IonPage } from "@ionic/react";
import { panels } from "components/CancelRequest/CancelRequestPanels";
import { PanelFlow } from "components/PanelFlow";

import { CancelPanelKey } from "~components/CancelRequest/constants";
import { SharedModalHeader } from "~components/Molecules";
import { translate } from "~utils";

import type { CancelModalProps, CancelRequestState } from "./types";

export const CancelRequestModal: React.FC<CancelModalProps> = ({
  request,
  onDismiss,
  onSubmit,
}) => {
  const [cancelRequestState, setCancelRequestState] = useState<CancelRequestState>({
    cancelReason: undefined,
    cancelExplanation: "",
    shouldRepost: undefined,
    response: undefined,
    request,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <IonPage>
      <SharedModalHeader title={translate("CANCEL_REQ_LABEL_HEADER")} onDismiss={onDismiss} />
      <IonContent
        css={{ "--ion-background-color": "white", paddingTop: "var(--ion-safe-area-top)" }}
      >
        <PanelFlow
          panels={panels}
          defaultPanelKey={CancelPanelKey.CancelReasonPanel}
          state={cancelRequestState}
          setState={setCancelRequestState}
          extraProps={{
            request,
            onDismiss,
            onSubmit,
            isSubmitting,
            setIsSubmitting,
          }}
        />
      </IonContent>
    </IonPage>
  );
};
